<template>
  <div class="home top-section-spacing" v-if="renderData">
    <Header :hideDrower="true" user />
    <TopSection
      heading="Create/ Manage Companies"
      user="J K"
      searchLabel="name"
      v-model="searchValue"
    />
    <v-container class="pt-2 table-container">
      <v-layout
        row
        wrap
        class="table-row blue py-2 px-4 cc__box-shadow relative"
      >
        <v-flex xs2 class="pl-3">
          <span class="white--text subheading font-weight-bold">Name</span>
          <v-btn
            icon
            ref="sortBtn"
            small
            :class="`ma-0 ml-1 mt-1 sort-btn hide-on-mobile ${
              asc.name ? 'asc' : ''
            }`"
            @click="sortBy('name')"
          >
            <v-icon class="white--text title">expand_more</v-icon>
          </v-btn>
        </v-flex>

        <v-flex class="pl-3" xs2 justify-center>
          <span class="white--text subheading font-weight-bold"
            >Current User</span
          >
          <v-btn
            icon
            ref="sortBtn"
            small
            :class="`ma-0 ml-1 mt-1 sort-btn hide-on-mobile ${
              asc.hasValidContract ? 'asc' : ''
            }`"
            @click="sortBy('hasValidContract')"
          >
            <v-icon class="white--text title">expand_more</v-icon>
          </v-btn>
        </v-flex>
        <v-flex class="pl-3" xs2 justify-center>
          <span class="white--text subheading font-weight-bold"
            >Centre Licences</span
          >
          <v-btn
            icon
            ref="sortBtn"
            small
            :class="`ma-0 ml-1 mt-1 sort-btn hide-on-mobile ${
              asc.totalGroupLicences ? 'asc' : ''
            }`"
            @click="sortBy('totalGroupLicences')"
          >
            <v-icon class="white--text title">expand_more</v-icon>
          </v-btn>
        </v-flex>
        <v-flex class="pl-3" xs2 justify-center>
          <span class="white--text subheading font-weight-bold"
            >Individual Licences</span
          >
          <v-btn
            icon
            ref="sortBtn"
            small
            :class="`ma-0 ml-1 mt-1 sort-btn hide-on-mobile ${
              asc.totalSingleLicences ? 'asc' : ''
            }`"
            @click="sortBy('totalSingleLicences')"
          >
            <v-icon class="white--text title">expand_more</v-icon>
          </v-btn>
        </v-flex>
        <v-flex class="pl-3" xs2 justify-center>
          <span class="white--text subheading font-weight-bold"
            >Guest Licences</span
          >
          <v-btn
            icon
            ref="sortBtn"
            small
            :class="`ma-0 ml-1 mt-1 sort-btn hide-on-mobile ${
              asc.guestLicencesTotal ? 'asc' : ''
            }`"
            @click="sortBy('guestLicencesTotal')"
          >
            <v-icon class="white--text title">expand_more</v-icon>
          </v-btn>
        </v-flex>
        <v-flex class="pl-3" xs2 justify-center>
          <span class="white--text subheading font-weight-bold">Edit</span>
        </v-flex>
      </v-layout>
      <simplebar
        scrollbarMinSize="5"
        data-simplebar-auto-hide="false"
        class="list-scroll-section"
      >
        <div v-if="!filteredList.length || noData" class="request-info">
          <div v-if="noData" class="title grey--text">No data available</div>
          <v-progress-circular
            v-if="!filteredList.length && !noData && noSearchResults"
            :size="50"
            indeterminate
            color="blue"
          ></v-progress-circular>
        </div>

        <div
          v-for="company in filteredList"
          :key="company.companyId"
          class="table-content"
        >
          <v-layout white row wrap class="table-row py-2 px-4">
            <v-flex xs2 class="pl-3">
              <a
                :href="`/contracts/${company.companyId}`"
                :title="`${company.name}`"
                class="blue--text text--darken-1 font-weight-regular text-capitalize subheading link"
              >
                {{ company.name }}
              </a>
            </v-flex>
            <v-flex class="pl-3" xs2 justify-center>
              <v-icon class="black--text">{{
                company.hasValidContract ? "check" : "close"
              }}</v-icon>
            </v-flex>
            <v-flex class="pl-3 sort-content" xs2 justify-center>
              <span class="primary--text subheading">{{
                company.currentGroupLicences + "/" + company.totalGroupLicences
              }}</span>
            </v-flex>
            <v-flex class="pl-3 sort-content" xs2 justify-center>
              <span class="primary--text subheading">{{
                company.currentSingleLicences +
                "/" +
                company.totalSingleLicences
              }}</span>
            </v-flex>
            <v-flex class="pl-3 sort-content" xs2 justify-center>
              <span class="primary--text subheading">0/0</span>
            </v-flex>
            <v-flex class="pl-3" xs2 justify-center>
              <v-btn
                :href="`/company/${company.companyId}`"
                flat
                small
                class="edit-btn blue--text text--darken-1 text-capitalize font-weight-regular subheading link"
                >Edit</v-btn
              >
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </div>
      </simplebar>

      <v-btn
        @click="createCompany"
        large
        color="blue"
        class="mt-4 pl-4 pr-3 text-icon-button ml-0 large-button-width"
      >
        <span
          class="white--text subheading text-capitalize font-weight-bold pl-3"
          >Add Company</span
        >
        <v-icon right class="white--text title">add</v-icon>
      </v-btn>
    </v-container>
  </div>
</template>

<style lang="scss">
.sort-btn {
  transition: transform 0.15s ease;
  &.asc {
    transform: rotate(180deg);
  }
}
</style>


<script>
let asc = {
  name: false,
  centreLicences: false,
  hasValidContract: false,
  individualLicences: false,
  guestLicences: false,
};
import router from "../router";
import company from "../services/company";
import AuthService from "../services/auth";

import TopSection from "../components/TopSection.vue";
import Header from "../components/Header.vue";
import simplebar from "simplebar-vue";

export default {
  name: "App",
  components: {
    Header,
    TopSection,
    simplebar,
  },
  data() {
    return {
      noData: false,
      asc,
      searchValue: "",
      value: "",
      companies: null,
      toEdit: null,
      renderData: false,
      noSearchResults: false,
    };
  },
  created() {
    this.authService = new AuthService();

    if (sessionStorage.cctoken === undefined) {
      const msalError = sessionStorage.getItem('msal.error.description')
      if (msalError) {
        this.handleMsalError(msalError)
      } else {
          this.msalLogin()
      }
    } else if (sessionStorage.userType != 1) {
      router.push("/contracts/" + sessionStorage.companyId);
    } else {
      this.fetchData();
      this.renderData = true;
    }
  },
  methods: {
    msalLogin() {
      this.authService.login();
    },
    handleMsalError(error) {
      switch (error.slice(0, 11)) {
        case 'AADB2C90118':
          this.msalResetPassword()
          break;
         case 'AADB2C99002':
           sessionStorage.clear();
           router.push("/no-account");
          break;
      
        default:
          this.msalLogin()
          break;
      }
    },
    msalResetPassword() {
      this.authService.resetPassword();
    },
    async fetchData() {
      this.companies = await company.getAll();
      if (this.companies.data.length == 0) {
        this.noData = true;
      }
    },
    sortBy(prop) {
      this.asc[prop] = !this.asc[prop];
      if (this.companies) {
        if (this.asc[prop]) {
          this.companies.data.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
        } else {
          this.companies.data.sort((a, b) => (a[prop] > b[prop] ? -1 : 1));
        }
      }
    },
    createCompany() {
      router.push("/company");
    },
  },
  computed: {
    filteredList() {
      if (this.companies != null) {
        this.noSearchResults = false;
        return this.companies.data.filter((company) => {
          return company.name
            .toLowerCase()
            .includes(this.searchValue.toLowerCase());
        });
      } else {
        this.noSearchResults = true;
        return [];
      }
    },
  },
};
</script>

